import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {SafePipe} from '../../../../common/pipes/safe.pipe';
import {SafeHtml} from '@angular/platform-browser';
import {ReportingService} from '../../../services/reporting.service';
import {ReportUnitDTO} from '../../../models/ReportUnitDTO';
import {FormControl} from '@angular/forms';
import {SharedService} from '../../../../common/services/shared-service';
import {SafeStringType} from 'src/app/modules/clm/types/safe-string-type.enum';

@Component({
  selector: 'app-reporting-view',
  templateUrl: './reporting-view.component.html',
  styleUrls: [
    './reporting-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ],
  providers: [SafePipe]
})
export class ReportingViewComponent implements OnInit {

  html: SafeHtml;
  reportUnitFormControl: FormControl;
  reportUnits: ReportUnitDTO[];
  isLoadingCounter: number;

  constructor(
    private changeDetect: ChangeDetectorRef,
    private safePipe: SafePipe,
    private reportingService: ReportingService,
    private sharedService: SharedService
  ) {
    this.reportUnitFormControl = new FormControl('');
    this.isLoadingCounter = 0;
  }

  ngOnInit(): void {
    this.getDashboardHtml();
    this.getListOfReports();

    this.sharedService.getHelpInfo('Reporting');

  }

  reportUnitSelected(label: string) {
    const selectedReportUnit = this.reportUnits.find(reportUnit => reportUnit.label === label);
    // TODO: render embedded report in iFrame
    // TODO: add dialog prompt for all parameters
    const url = this.reportingService.buildEmbeddedReportUrl(selectedReportUnit.uri);
    window.open(url, '_blank');
  }

  getInfoTooltip(inputName: string): string {
    return this.sharedService.getInfoTooltip(inputName);
  }

  private getListOfReports() {
    this.isLoadingCounter++;
    this.reportingService.getListOfReports().subscribe(
      (result) => {
        this.reportUnits = result.resourceLookup;
        // TODO: set chosen option to the dashboard
        // this.reportUnitFormControl.setValue(this.reportUnits[0].label);
      },
      () => {
        this.sharedService.openErrorDialog('There was an error getting the list of reports');
      },
      () => {
        this.isLoadingCounter--;
      }
    );
  }

  private getDashboardHtml() {
    this.isLoadingCounter++;
    this.reportingService.getReportHtml('/Reports/Processing_Performance_Dashboard', '').subscribe(
      (result) => {
        this.html = this.safePipe.transform(result, SafeStringType.Html);
      },
      () => {
        this.sharedService.openErrorDialog('There was an error generating the report');
      },
      () => {
        this.isLoadingCounter--;
      }
    );
  }

}
